<!-- Minimized tray — small dock, not the full card -->
<div class="sg-tray" *ngIf="visible && collapsed" (click)="toggleCollapse()">
  <span class="sg-tray__badge" *ngIf="!allDone">{{ doneCount }}/{{ steps.length + quickLinks.length }}</span>
  <span class="sg-tray__badge sg-tray__badge--done" *ngIf="allDone">🎉</span>
</div>

<div class="sg-widget" *ngIf="visible && !collapsed">

  <div class="sg-widget__header" (click)="toggleCollapse()">
    <span class="sg-widget__title">Payments and Payouts</span>
    <div class="sg-widget__actions">
      <span class="sg-widget__badge" *ngIf="!allDone">{{ doneCount }}/{{ steps.length + quickLinks.length }}</span>
      <ion-icon name="chevron-down-outline"></ion-icon>
      <ion-icon name="close-outline" (click)="dismiss($event)"></ion-icon>
    </div>
  </div>

  <div class="sg-widget__footer" *ngIf="allDone">
    <div class="sg-widget__footer-icon">🎉</div>
    <div>
      <strong>You're all set!</strong>
      <div class="sg-widget__footer-sub">Stripe is connected and a payment plan is in place.</div>
    </div>
  </div>

  <!-- Connect Stripe, then the fee-payer quick link right below it, then
       Add payment for a kid, then the history quick link. The two
       trackable steps strike through in place as each completes, and both
       hide together once allDone (celebration shows instead); the quick
       links always stay, whether or not setup is finished. -->
  <div class="sg-widget__list">
    <ng-container *ngIf="!allDone">
      <div class="sg-row" [class.done]="steps[0].done" (click)="onStepClick(steps[0])">
        <span class="sg-row__dot"></span>
        <span class="sg-row__label">{{ steps[0].label }}</span>
        <ion-icon *ngIf="!steps[0].done" name="chevron-forward-outline" class="sg-row__chev"></ion-icon>
      </div>
    </ng-container>
    <div class="sg-row" (click)="onStepClick(quickLinks[0])">
      <span class="sg-row__dot"></span>
      <span class="sg-row__label">{{ quickLinks[0].label }}</span>
      <ion-icon name="chevron-forward-outline" class="sg-row__chev"></ion-icon>
    </div>
    <ng-container *ngIf="!allDone">
      <div class="sg-row" [class.done]="steps[1].done" (click)="onStepClick(steps[1])">
        <span class="sg-row__dot"></span>
        <span class="sg-row__label">{{ steps[1].label }}</span>
        <ion-icon *ngIf="!steps[1].done" name="chevron-forward-outline" class="sg-row__chev"></ion-icon>
      </div>
    </ng-container>
    <div class="sg-row" (click)="onStepClick(quickLinks[1])">
      <span class="sg-row__dot"></span>
      <span class="sg-row__label">{{ quickLinks[1].label }}</span>
      <ion-icon name="chevron-forward-outline" class="sg-row__chev"></ion-icon>
    </div>
  </div>

</div>
